import routes from './routes'
import { LobbyEntryProps, LobbyEntryTypes } from './components/LobbyEntry/LobbyEntry'

// audio
import LobbyMusic from './images/audio/lobby.mp3'

// icons & decorations
import { desktopAssets } from './containers/PreCache'
import { GlobalModalTypes } from './components/GlobalModals/GlobalModalContainer'

const dev = {
  apiUrl: 'http://localhost:3000',
}

const prod = {
  apiUrl: 'https://backend.pamagencyevents.com',
}

const API_KEYS = {
  amplitude: '6f2ff599c78fbeb4f61ea02774f1fb27',
}

const LOBBY_VIDEO = 'https://iframe.dacast.com/playlist/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/79970b66-c4a5-f9b8-06ed-c38de050a0f7'
const HALL_VIDEO_URL = 'https://iframe.dacast.com/live/1b1f6ca6-faef-317f-74bf-a4ce68f8e2d6/fed8d9b3-133e-434b-8229-872174b0568d'
const SLIDO_URL = 'https://app.sli.do/event/7Tz5oUee62JoJim2B79XGZ'
const VOLUME_VALUE = 0.4

// Root page will show either EntrancePage or CountdownPage
// based on the following time setting
const EVENT_START_TIME = {
  year: 2026,
  month: 4,
  day: 7,
  hour: 9,
  minute: 30,
}

const PLAY_END_TIME = {
  year: 2026,
  month: 4,
  day: 7,
  hour: 10,
  minute: 30,
}

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 10%;
    left: 5%;
    right: 32%;
    bottom: 20%;
  `,
}

const lobbyEntries: Array<LobbyEntryProps & { id: string }> = [
  {
    id: 'programme-icon',
    type: LobbyEntryTypes.GlobalModal,
    modalId: GlobalModalTypes.Agenda,
    pinImage: desktopAssets.agendaIcon,
    pinText: 'Programme',
    textCss: `
      position: absolute;
      left: 0%;
      bottom: 0%;
      opacity: 0;
      animation: fadeIn 0.5s forwards;
    `,
    css: `
      top: 58%;
      left: 64%;
      width: 100px !important;
      animation: float 3s ease-in-out infinite;
      animation-delay: 1000ms;

      &:hover {
        .pinText {
          opacity: 1;
        }
      }
    `,
    //animation: glowPulse 2s infinite;
  },
  {
    id: 'helpdesk',
    type: LobbyEntryTypes.Helpdesk,
    pinImage: desktopAssets.lobbyHelpDeskIcon,
    pinText: 'Helpdesk',
    textCss: `
      position: absolute;
      left: 10%;
      bottom: 0%;
      opacity: 0;
      animation: fadeIn 0.5s forwards;
    `,
    css: `
      top: 63%;
      left: 51%;
      width: 100px;
      animation: float 3s ease-in-out infinite;
      animation-delay: 500ms;
      display: flex;
      align-items: end;

      &:hover {
        .pinText {
          opacity: 1;
        }
      }

      @media (min-width: 1279px) {
        width: 90px;
      }

      @media (min-width: 1439px) {
        width: 100px;
      }
    `,
    pinImageCss: `
    `,
  },
  {
    id: 'auditorium-entrance',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.auditorium,
    pinImage: desktopAssets.hallIcon,
    pinText: 'Auditorium',
    textCss: `
    width: 133px;
      position: absolute;
          bottom: 0%;
    left: -11%;
      opacity: 0;
      animation: fadeIn 0.5s forwards;
    `,
    css: `
      top: 50%;
      left: 85%;
      width: 100px !important;
      animation: float 3s ease-in-out infinite;
      animation-delay: 500ms;
      &:hover {
        .pinText {
          opacity: 1;
        }
      }

    `,
  },
  {
    id: 'networking',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.networking,
    pinImage: desktopAssets.networkingIcon,
    pinText: 'Networking',
    textCss: `
    width: 133px;
      position: absolute;
          bottom: -0%;
    left: -17%;
      opacity: 0;
      animation: fadeIn 0.5s forwards;

      @media (max-width: 1280px) {
        left: -30%;
      }
    `,
    css: `
      animation: float 3s ease-in-out infinite;
      animation-delay: 100ms;
      width: 100px;
      top: 56%;
      left: 13%;

      &:hover {
        .pinText {
          opacity: 1;
        }
      }


      @media (min-width: 1279px)  {
        width: 80px;
      }

      @media (min-width: 1439px) {
        width: 100px;
      }
    `,
  },
  // {
  //   id: 'gallery-entrance',
  //   type: LobbyEntryTypes.DirectRoute,
  //   destination: routes.onDemand,
  //   pinImage: desktopAssets.galleryIcon,
  //   css: `
  //     top: 22%;
  //     left: 66%;
  //     width: 9% !important;
  //     animation: float 3s ease-in-out infinite;
  //     animation-delay: 1500ms;
  //   `,
  // },
  // {
  //   id: 'game',
  //   type: LobbyEntryTypes.DirectRoute,
  //   destination: routes.game,
  //   pinImage: desktopAssets.gameIcon,
  //   pinText: 'Fast & Furious Top 30',
  //   textCss: `
  //     position: absolute;
  //         bottom: -10%;
  //   left: -49%;
  //   width: 200px;
  //     opacity: 0;
  //     animation: fadeIn 0.5s forwards;

  //     @media (max-width: 1280px) {
  //       bottom: -10%;
  //     }
  //   `,
  //   css: `
  //     top: 56.3%;
  //     left: 66%;
  //     width: 100px;
  //     animation: float 3s ease-in-out infinite;
  //     animation-delay: 200ms;

  //     &:hover {
  //       .pinText {
  //         opacity: 1;
  //       }
  //     }

  //     @media (min-width: 1279px) {
  //       width: 80px;
  //     }

  //     @media (min-width: 1439px) {
  //       width: 95px;
  //     }
  //   `,
  // },
  // {
  //   id: 'survey',
  //   type: LobbyEntryTypes.ExternalRoute,
  //   destination: routes.survey,
  //   pinImage: desktopAssets.surveyIcon,
  //   css: `
  //     top: 61%;
  //     left: 38.5%;
  //     width: 8% !important;
  //     animation: float 3s ease-in-out infinite;
  //     animation-delay: 1500ms;
  //   `,
  // },
  // {
  //   id: 'exhibition-entrance',
  //   type: LobbyEntryTypes.GlobalModal,
  //   modalId: GlobalModalTypes.EntrySelection,
  //   pinImage: fixedAssets.exhibitionEntrance,
  //   css: `
  //     top: 45%;
  //     left: 63%;
  //     right: 22%;
  //     bottom: 16%;
  //   `,
  //   pinText: "EXHIBITION HALL",
  //   textCss: `
  //     top: 30%;
  //     left: 7%;
  //     right: 22%;
  //     bottom: 42%;
  //     transform: rotateX(0deg) rotateY(-15deg);
  //   `,
  // },
  // {
  //   id: 'welcome video',
  //   type: LobbyEntryTypes.GlobalModal,
  //   modalId: GlobalModalTypes.Welcome,
  //   pinImage: fixedAssets.playIcon,
  //   css: `
  //     top: 30%;
  //     left: 45%;
  //     right: 45%;
  //     bottom: 55%;
  //   `,
  // },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,
  EVENT_START_TIME,
  SLIDO_URL,
  HALL_VIDEO_URL,
  LOBBY_VIDEO,
  eventName: 'Principal 2026 Q2 Agency Rolldown',
  PLAY_END_TIME,
  ...config,
}
